import React, { useEffect, useState } from "react";

import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import IconButton from "@mui/material/IconButton";
import SaveIcon from "@mui/icons-material/Save";

import { Box, CircularProgress, Grid, TextField, Tooltip, Typography } from "@mui/material";
import ParametroPortalDataset from "../../../components/data/parametroPortalDataset";
import ParametroPortal from "../../../components/classes/ParametroPortal";
import Notification from "../../../components/common/Notification";

import { useTranslation } from "react-i18next";

export default function ConfigurationModal(
  props: ConfigurationModalProps
) {
  const { t } = useTranslation();

  const [dias, setDias] = useState<Number>();
  const [diasParametro, setDiasParametro] = useState<ParametroPortal>();
  const [hora, setHora] = useState<String>();
  const [horaParametro, setHoraParametro] = useState<ParametroPortal>();
  const [situacaoParametro, setSituacaoParametro] = useState<ParametroPortal>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' })

  const dataSet = new ParametroPortalDataset();

  useEffect(() => {
    loadData();
  }, [])

  const loadData = async () => {
    try {
      setIsLoading(true);

      let parametros = await dataSet.ListarAtivos();

      let parametroHora = parametros.find(x => x.rotinaId == 37 && x.descricao == 'Hora');
      let parametroDias = parametros.find(x => x.rotinaId == 37 && x.descricao == 'Dias Entre');
      let parametroSituacao = parametros.find(x => x.rotinaId == 37 && x.descricao == 'Situação');

      if (parametroDias) {
        setDias(+parametroDias.valorPadrao)
        setDiasParametro(parametroDias)
      }

      if (parametroHora) {
        setHora(parametroHora.valorPadrao)
        setHoraParametro(parametroHora)
      }

      if (parametroSituacao) {
        setSituacaoParametro(parametroSituacao);
      }

    } catch (err) {
      console.log(err)
    }
    finally {
      setIsLoading(false);
    }
  }

  const saveData = async () => {
    try {
      setIsLoading(true);

      if (!dias)
        throw t("pages.importRequest.text.daysBetweenRequired")

      if (!hora)
        throw t("pages.importRequest.text.timeRequired")

      if (diasParametro) {
        diasParametro.valorPadrao = dias + '';
        await dataSet.Atualizar(diasParametro);
      } else {
        let parametro = new ParametroPortal();
        parametro.d_E_L_E_T_E = false;
        parametro.descricao = 'Dias Entre';
        parametro.rotinaId = 37;
        parametro.valorPadrao = dias + '';
        await dataSet.Adicionar(parametro);
      }

      if (horaParametro) {
        horaParametro.valorPadrao = hora + '';
        await dataSet.Atualizar(horaParametro);
      } else {
        let parametro = new ParametroPortal();
        parametro.d_E_L_E_T_E = false;
        parametro.descricao = 'Hora';
        parametro.rotinaId = 37;
        parametro.valorPadrao = hora + '';
        await dataSet.Adicionar(parametro);
      }

      if (!situacaoParametro) {
        let parametro = new ParametroPortal();
        parametro.d_E_L_E_T_E = false;
        parametro.descricao = 'Situação';
        parametro.rotinaId = 37;
        parametro.valorPadrao = 'Ativo';
        await dataSet.Adicionar(parametro);
      }

      setNotify({
        isOpen: true,
        message: 'Salvo com sucesso.',
        type: 'success'
      })

      await loadData();

    } catch (err: any) {
      console.log(err)
      setNotify({
        isOpen: true,
        message: err,
        type: 'error'
      })
    }
    finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <div className="containerForecastModal" style={{ width: "600px" }}>
        <div className="containerTitleModal">
          <div className="containerTitle">
            <Typography
              variant="h5"
              fontFamily={"Co Headline Regular"}
              gutterBottom
              align="left"
              marginLeft="15px"
            >
              {t("pages.importRequest.text.config")}
            </Typography>
          </div>
        </div>
        <div className="containerToolbarModal">
          <Tooltip title={t("pages.importRequest.text.saveConfigs")}>
            <IconButton onClick={() => { saveData() }}>
              <SaveIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={t("pages.importRequest.text.exitConfigs")}>
            <IconButton onClick={props.handleClose}>
              <ExitToAppIcon />
            </IconButton>
          </Tooltip>
        </div>
        <div className="insiderContainerModal">
          {
            isLoading ?
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                minHeight="40vh"
              >
                <CircularProgress size={48} />
                <small style={{ marginTop: 10 }}>{t("pages.importRequest.text.waitPlease")}.</small>
              </Box>
              :
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography align="center" fontSize={15}>{t("pages.importRequest.text.differenceLimit")}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    id="dias"
                    name="dias"
                    fullWidth
                    variant="outlined"
                    type="number"
                    value={dias}
                    onChange={(e) => setDias(+e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography align="center" fontSize={15}>{t("pages.importRequest.text.timeForAutomaticRoutine")}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    id="hora"
                    name="hora"
                    fullWidth
                    variant="outlined"
                    value={hora}
                    type="time"
                    onChange={(e) => setHora(e.target.value)}
                  />
                </Grid>
              </Grid>
          }
        </div>
      </div>
      <Notification
        notify={notify}
        setNotify={setNotify}
      />
    </>
  );
}

interface ConfigurationModalProps {
  handleClose: any;
}
